import { VStack } from '@hover/blueprint';
import React from 'react';

import { useHomeownerAppContext } from '../../hooks/useHomeownerAppContext';
import { Footer } from '../Footer';

import { LoggedInFavorites } from './LoggedInFavorites';
import { LoggedOutFavorites } from './LoggedOutFavorites';

const Favorites = () => {
  const { loggedIn } = useHomeownerAppContext();

  return (
    <div>
      {loggedIn ? (
        <LoggedInFavorites />
      ) : (
        <VStack>
          <LoggedOutFavorites />
          <Footer theme="dark" />
        </VStack>
      )}
    </div>
  );
};

export { Favorites };
